import classnames from 'classnames';
import React from 'react';
const EmptyListMessage = (props) => {
    if (props.buttonLink == '/') {
        throw new Error('buttonLink may never be /');
    }
    return (React.createElement("div", { className: classnames('list__empty-message', props.className) },
        React.createElement("p", { className: "empty-message__text", dangerouslySetInnerHTML: { __html: props.text } }),
        React.createElement("a", { href: props.buttonLink, className: "button button--secondary", onClick: () => (!!props.pushAnalytics ? props.pushAnalytics() : null) },
            React.createElement("span", null, props.buttonText))));
};
export default EmptyListMessage;
